module.exports = __webpack_public_path__ + "u17.no2.44a5fb21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/u17.no2.jpg
// module id = UYu6
// module chunks = 0